import React, { useState } from 'react';
import styled from 'styled-components';
import { LayoutColors } from '@src/core/theme';
import { MdWarning } from 'react-icons/md';
import useTranslate from '@src/i18n/useTranslate';
import FilledButton from '@src/components/reusable/button/FilledButton';
import { BackdropModal } from '@src/components/reusable';
import PhoneVerification from '@src/features/customers/auth/phone-verification/components/AccountVerification';
import { device } from '@src/common/breakpoints';

export const PhoneVerificationAlert = () => {
  const { i18n } = useTranslate();

  const [verificationModalOpen, setVerificationModalOpen] = useState(false);

  return (
    <>
      <Alert>
        <Message>
          <MdWarning color={LayoutColors.whiteDark} size={18} style={{ marginRight: '5px' }} />
          {i18n('checkout_phone_verification_alert_message')}
        </Message>

        <Button
          bgColor={LayoutColors.whiteLight}
          textColor={LayoutColors.warningDark}
          onClick={() => setVerificationModalOpen(true)}
          disabled={false}
        >
          {i18n('checkout_phone_verification_alert_button')}
        </Button>
      </Alert>

      <BackdropModal visible={verificationModalOpen} closeModal={() => setVerificationModalOpen(false)}>
        <Wrapper>
          {verificationModalOpen ? (
            <PhoneVerification
              onBack={() => setVerificationModalOpen(false)}
              onSuccess={() => setVerificationModalOpen(false)}
            />
          ) : null}
        </Wrapper>
      </BackdropModal>
    </>
  );
};

export default PhoneVerificationAlert;

const Message = styled.div`
  display: flex;
`;

const Alert = styled.div`
  background-color: ${LayoutColors.warningDark};
  font-weight: bold;
  color: ${LayoutColors.whiteLight};
  width: 100%;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Button = styled(FilledButton)`
  width: 120px;
  color: ${LayoutColors.warningDark};
`;

const Wrapper = styled.article`
  width: 100%;
  pointer-events: all;
  overflow: hidden;
  max-width: 533px !important;
  margin: 0 auto;
  margin-top: 120px;
  background-color: white;
  padding: 24px;

  ${device.smallTablet} {
    border-radius: 8px;
  }
`;
